import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

let quiz = document.getElementById('quiz')
if (quiz) {
  ReactDOM.render(<App />, quiz);
}




// WEBPACK FOOTER //
// ./src/index.js